// extracted by mini-css-extract-plugin
module.exports = {"sticky-active":"horizontal_sticky-active__zEXQ_","sticky-navbar":"horizontal_sticky-navbar__O83Hf","nav-link":"horizontal_nav-link__CKP9i"};